/* MAIRAZ conversion and performance refinements — 18 Sep 2026. */
(function () {
  'use strict';

  /* Mairaz 19 Sep 2026 - estimated arrival.
     Counted in WORKING days (weekends skipped) and driven by the Delivery
     Option radio, so Express and Standard never show the same date:
       Express  6-10 working days   Standard 14-20 working days
       Pakistan  4-7 working days  (no Delivery Option control renders there)
     Public holidays are not modelled, which is why the copy says "estimated". */
  var MRZ_WINDOWS = {
    express: [6, 10],
    standard: [14, 20],
    pk: [4, 7]
  };

  function addWorkingDays(date, days) {
    var next = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < days) {
      next.setDate(next.getDate() + 1);
      var day = next.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return next;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'long', day: 'numeric' }).format(date);
  }

  function isSocialWebView() {
    return /Instagram|FBAN|FBAV|FB_IAB|FBIOS|FB4A/i.test(navigator.userAgent || '');
  }

  function formatRange(start, end) {
    if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
      return formatDate(start) + ' to ' + end.getDate();
    }
    return formatDate(start) + ' to ' + formatDate(end);
  }

  /* Reads the radio the customer has actually selected. Returns null when the
     control is absent (Pakistan, or a template without the selector). */
  function selectedDeliveryMode(scope) {
    var radios = (scope || document).querySelectorAll('input[name="properties[Delivery Option]"]');
    if (!radios.length) return null;
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return /^\s*express/i.test(radios[i].value || '') ? 'express' : 'standard';
    }
    return 'standard';
  }

  function updateDeliveryAssurance(root) {
    root = root || document;
    root.querySelectorAll('[data-mrz-delivery-assurance]').forEach(function (element) {
      var country = (element.getAttribute('data-country') || '').toUpperCase();
      var copy = element.querySelector('[data-mrz-delivery-copy]');
      var arrival = element.querySelector('[data-mrz-arrival]');

      var mode = selectedDeliveryMode(document);
      var key = country === 'PK' ? 'pk' : (mode || 'standard');
      var window_ = MRZ_WINDOWS[key] || MRZ_WINDOWS.standard;

      if (copy) {
        if (country === 'PK') copy.textContent = 'Free delivery across Pakistan. Made to order.';
        else if (country === 'US') copy.textContent = 'Free standard shipping to the US. Express delivery is available.';
        else copy.textContent = 'Free standard shipping to supported destinations. Express delivery is available.';
      }

      if (arrival) {
        var start = addWorkingDays(new Date(), window_[0]);
        var end = addWorkingDays(new Date(), window_[1]);
        var label = key === 'express' ? ' with Express' : (key === 'standard' ? ' with free standard delivery' : '');
        arrival.textContent = 'Estimated arrival: ' + formatRange(start, end) + label;
      }
    });
  }

  /* One delegated listener, bound once, so the date re-renders the moment the
     customer switches between Express and Standard. */
  function watchDeliveryOption() {
    if (document.documentElement.getAttribute('data-mrz-delivery-watch') === 'true') return;
    document.documentElement.setAttribute('data-mrz-delivery-watch', 'true');
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.name !== 'properties[Delivery Option]') return;
      updateDeliveryAssurance(document);
    });
  }

  function simplifyShippingMessaging(root) {
    root = root || document;
    root.querySelectorAll('#CartDrawer .tax-note, .cart-drawer .tax-note').forEach(function (note) {
      note.textContent = 'Free standard shipping. Express delivery is available at checkout.';
    });
    root.querySelectorAll('.product__tax').forEach(function (note) {
      if (/shipping\s+calculated\s+at\s+checkout/i.test(note.textContent || '')) note.textContent = 'Free standard shipping. Express delivery is available.';
    });
  }

  function markSocialWebView() {
    if (isSocialWebView()) document.documentElement.setAttribute('data-mrz-social-webview', 'true');
    else document.documentElement.removeAttribute('data-mrz-social-webview');
  }

  function trimUnusedReviewDialog(root) {
    root = root || document;
    root.querySelectorAll('.mrz-trv').forEach(function (section) {
      if (section.querySelector('[data-mrz-reviews-open]')) return;
      section.querySelectorAll('.mrz-trv__dialog').forEach(function (dialog) { dialog.remove(); });
    });
  }

  function softenEmptyRatings(root) {
    root = root || document;
    root.querySelectorAll('.jdgm-rev-widg__summary-average, .jdgm-all-reviews-rating-wrapper, .rating-wrapper').forEach(function (widget) {
      var text = (widget.textContent || '').replace(/\s+/g, ' ').trim();
      if (text !== '0.0' && text !== '0') return;
      if (!widget.querySelector('.jdgm-rev, .jdgm-rev__title, [data-review-count]:not([data-review-count="0"])')) widget.style.display = 'none';
    });
  }

  function evergreenPromotions(root) {
    root = root || document;
    root.querySelectorAll('h1, h2, h3, .banner__heading, .announcement-bar__message, .mrz-promo__eyebrow, .mrz-promo__heading').forEach(function (element) {
      var value = element.textContent || '';
      if (!/this summer|summer sale|limited[- ]time/i.test(value)) return;
      element.textContent = value
        .replace(/\bthis summer\b[,:]?\s*/gi, '')
        .replace(/\bthe mairaz summer sale\b/gi, 'THE MAIRAZ SALE')
        .replace(/\bmairaz summer sale\b/gi, 'MAIRAZ SALE')
        .replace(/\blimited[- ]time\b[,:]?\s*/gi, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+([.!?])/g, '$1');
    });
  }

  function observeCartDrawer() {
    var drawer = document.querySelector('#CartDrawer, .cart-drawer');
    if (!drawer || drawer.getAttribute('data-mrz-shipping-observed') === 'true') return;
    drawer.setAttribute('data-mrz-shipping-observed', 'true');
    new MutationObserver(function () { simplifyShippingMessaging(drawer); }).observe(drawer, { childList: true, subtree: true });
  }

  function pauseMobileInstagramAutoplay() {
    if (!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches) && !isSocialWebView()) return;
    document.querySelectorAll('mairaz-instagram-reels').forEach(function (section) {
      var state = section.mrzAutoplayState;
      if (state && typeof state.cleanup === 'function' && section.getAttribute('data-mrz-autoplay-cleaned') !== 'true') {
        state.cleanup();
        section.setAttribute('data-mrz-autoplay-cleaned', 'true');
      }
    });
    if (window.mrzIgTouch && typeof window.mrzIgTouch.stop === 'function') window.mrzIgTouch.stop();
  }

  function scheduleMobileFeedCleanup() {
    if (!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches) && !isSocialWebView()) return;
    [900, 2400, 5200].forEach(function (delay) { setTimeout(pauseMobileInstagramAutoplay, delay); });
  }

  function onIdle(callback) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(callback, { timeout: 1500 });
    else setTimeout(callback, 700);
  }

  function runImmediate(root) {
    watchDeliveryOption();
    updateDeliveryAssurance(root);
    simplifyShippingMessaging(root);
    markSocialWebView();
    trimUnusedReviewDialog(root);
    observeCartDrawer();
    scheduleMobileFeedCleanup();
  }

  function runDeferred(root) {
    onIdle(function () {
      softenEmptyRatings(root);
      evergreenPromotions(root);
    });
  }

  function boot() {
    runImmediate(document);
    runDeferred(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target || document;
    runImmediate(root);
    runDeferred(root);
  });
})();
